export const SOCIAL_LINKS = ['LinkedIn', 'Instagram', 'X', 'Facebook'];

export const SOCIAL_LINKS_ALIAS = {
  Twitter: 'X',
} as { [key: string]: string };
